import React from "react";
import {FormattedNumber} from "react-intl";
import PropTypes from 'prop-types';

const FormattedAchievementTimes =({achievementResult, achievement}) => {
    switch (achievement.valueType) {
        case 'FLOAT':
            return <FormattedNumber
                value={achievementResult.times}
                minimumFractionDigits={2}
                maximumFractionDigits={2}
            />;
        case 'INTEGER':
        case 'BOOL':
        default:
            return <span>{achievementResult.times}</span>;
    }
};

FormattedAchievementTimes.propTypes = {
    achievementResult: PropTypes.shape({
        times: PropTypes.number.isRequired
    }).isRequired,
    achievement: PropTypes.shape({
        valueType: PropTypes.string.isRequired
        }
    ).isRequired
};

export default FormattedAchievementTimes;